// Wikifactory Theme colors

export default {
  // WF colors
  wfWhite: '#ffffff',
  wfBlack: '#000000',

  wfGrey: '#3d3d3d',
  wfGrey900: '#444444',
  wfGrey800: '#5D5D5D',
  wfGrey700: '#727272',
  wfGrey600: '#838383',
  wfGrey500: '#909090',
  wfGrey400: '#adadad',
  wfGrey300: '#cfcfcf',
  wfGrey200: '#e6e6e6',
  wfGrey100: '#ECECEC',

  wfYellow: '#ffcb00',
  wfYellow900: '#FED119',
  wfYellow800: '#FFD632',
  wfYellow700: '#FFDB4D',
  wfYellow600: '#FFE066',
  wfYellow500: '#FFE680',
  wfYellow400: '#FFEB99',
  wfYellow300: '#FFEFB2',
  wfYellow200: '#FFF4CC',
  wfYellow100: '#FFFAE6',

  wfBlue: '#0f2eff',
  wfBlue900: '#1950FF',
  wfBlue800: '#3363FF',
  wfBlue700: '#4D76FF',
  wfBlue600: '#658BFF',
  wfBlue500: '#809DFF',
  wfBlue400: '#98B1FF',
  wfBlue300: '#B2C4FF',
  wfBlue200: '#CCD8FF',
  wfBlue100: '#E6ECFF',

  wfGreen: '#00d54c',
  wfGreen900: '#19D46E',
  wfGreen800: '#33D97E',
  wfGreen700: '#4CDE8E',
  wfGreen600: '#67E39E',
  wfGreen500: '#80E7AF',
  wfGreen400: '#98ECBF',
  wfGreen300: '#B2F1CF',
  wfGreen200: '#CCF6DF',
  wfGreen100: '#E6FBEF',

  wfRed: '#ff1111',

  wfOrange: '#ff4d00',
  wfOrange900: '#FF6E18',
  wfOrange800: '#FF7D34',
  wfOrange700: '#FF8E4C',
  wfOrange600: '#FF9E66',
  wfOrange500: '#FFAE7F',
  wfOrange400: '#FFBE98',
  wfOrange300: '#FFCFB2',
  wfOrange200: '#FFDECC',
  wfOrange100: '#FFEFE6',

  wfPurple: '#9000ff',
  wfPurple900: '#8F40FF',
  wfPurple800: '#9C56FF',
  wfPurple700: '#A86BFF',
  wfPurple600: '#B57FFF',
  wfPurple500: '#C095FF',
  wfPurple400: '#CDAAFF',
  wfPurple300: '#DAC0FE',
  wfPurple200: '#E6D5FF',
  wfPurple100: '#F3EAFF',

  wfPink: '#ff00ff',

  // Theme colors
  primary: '#0f2eff',
  primaryLight: '#809DFF',
  primaryLightest: '#E6ECFF',
  primaryDark: '#00218E',
};
